module.exports = __webpack_public_path__ + "static/djangoworkshop-08757b79d5215537bf0f7a04a54f1633.jpg";